import React, { useEffect, useState } from "react";

import { 
  Grid,
  Box, 
  TextField,
  Container
} from "@material-ui/core";
import Button from "../Fields/Button";

import { connect } from "react-redux";
import UserCard from "../../UserCard";
import { useStyles } from "./styles";
import PageSelector from "../../Shared/PageSelector";
import Loading from "../../Loading";

const ListUsers = ({ getUsers, users, groups, loading }) => {
  const classes = useStyles();
  const [currentPage, setCurrentPage] = useState(1);
  const isTransporterAdmin =
    groups && groups.includes("user_admin") && groups.includes("transporter");

  const [filterByUserNameOrPhone, setFilterByUserNameOrPhone] = useState('');
  
  async function handleSearch() {
    isTransporterAdmin &&
        getUsers({ types: ["transporter"], page: currentPage, filterByUserNameOrPhone });
      !isTransporterAdmin &&
        getUsers({ types: ["driver", "transporter", "client", "vendor"], page: currentPage, searchString: filterByUserNameOrPhone });
  }

  useEffect(() => {
  }, [getUsers, currentPage, isTransporterAdmin]);

  useEffect(() => {
    handleSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {}, [users]);

  useEffect(() => {}, [filterByUserNameOrPhone]);

  return (
    <Grid className={classes.root} id="scrollableDiv">
      <Grid className={classes.items}>
        <Grid item>
          <h3>Listando {users.length} resultados</h3>
        </Grid>
        <PageSelector
          users={users}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      </Grid>
      <Container className={classes.containerFilter}>
        <Box className={classes.filter}>
          {<TextField
            variant="outlined"
            type="search"
            value={filterByUserNameOrPhone}
            onChange={(e) => {
              setFilterByUserNameOrPhone(e.target.value)
            }}
            onKeyDown={(e)=>{
              if (e.key === 'Enter') {
                e.preventDefault();
                handleSearch();
              }
            }}
            placeholder="Filtrar por nome, e-mail ou telefone"
          />}
          <Button
              onClick={() => {
                handleSearch();
              }}
              icon="search"
              className={classes.userButton}
              data-cy="manager-user-search-icon"
              id="manager-user-search-icon"
            />
        </Box>
      </Container>
      <>
        {loading && <Loading />}
        {users.map((i, index) => (
          <UserCard key={index} user={i} />
        ))}
      </>
      <Grid className={classes.items}>
        <Grid item />
        <PageSelector
          users={users}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      </Grid>
    </Grid>
  );
};
const mapState = (state) => ({
  users: state.users.users,
  loading: state.users.loading,
  groups: state.auth.user.groups,
});

const mapDispatch = (dispatch) => ({
  getUsers: (payload) => dispatch.users.getUsersAsync(payload),
});

export default connect(mapState, mapDispatch)(ListUsers);
